import Navbar from '@/components/Navbar';
import Hero from '@/components/Hero';
import TrustBand from '@/components/TrustBand';
import ProgressionSection from '@/components/ProgressionSection';
import Features from '@/components/Features';
import HowItWorks from '@/components/HowItWorks';
import StatsCounters from '@/components/StatsCounters';
import Champions from '@/components/Champions';
import Disciplines from '@/components/Disciplines';
import ClayoSection from '@/components/ClayoSection';
import Pricing from '@/components/Pricing';
import FAQ from '@/components/FAQ';
import FinalCTA from '@/components/FinalCTA';
import Footer from '@/components/Footer';

export default function Home() {
  return (
    <div className="min-h-screen bg-[#0D0D0D]">
      <Navbar />
      <Hero />
      <TrustBand />
      <ProgressionSection />
      <Features />
      <HowItWorks />
      <StatsCounters />
      <Champions />
      <ClayoSection />
      <Disciplines />
      <Pricing />
      <FAQ />
      <FinalCTA />
      <Footer />
    </div>
  );
}
